import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn" }
const _hoisted_2 = { class: "container py-5" }
const _hoisted_3 = { class: "row g-5" }
const _hoisted_4 = { class: "col-lg-6 col-md-6" }
const _hoisted_5 = { class: "section-title ff-secondary text-start text-primary fw-normal mb-4" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "col-lg-6 col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", { class: "section-title ff-secondary text-start text-primary fw-normal mb-4" }, "Thời gian mở cửa", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.storeModel.name), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeModel!.phone!, (item, index) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "mb-2",
              key: index
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-phone me-3" }),
              _createTextVNode(" " + _toDisplayString(item), 1)
            ]))
          }), 128)),
          _createElementVNode("p", _hoisted_6, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-envelope me-3" }),
            _createTextVNode(" " + _toDisplayString(_ctx.storeModel.email), 1)
          ]),
          _createElementVNode("p", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-map-marker-alt me-3" }),
            _createTextVNode(" " + _toDisplayString(_ctx.storeModel.address), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeModel!.workingTime!, (item, index) => {
            return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(item), 1))
          }), 128))
        ])
      ])
    ])
  ]))
}